// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"daba114c","488":"13edf739","977":"390f2ab9"}[chunkId] + ".chunk.js";
};